<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="submit($event)"
  (cancel)="cancel()"
>
  <div class="flex--container">
    <mat-form-field class="full-width-field">
      <mat-label>{{ 'name' | translate }}</mat-label>
      <input
        matInput
        formControlName="name"
        [placeholder]="'name' | translate"
        data-test="treatment-schema-name"
      />
    </mat-form-field>

    <mat-form-field class="full-width-field">
      <mat-label>{{ 'description' | translate }}</mat-label>

      <input
        matInput
        formControlName="description"
        [placeholder]="'description' | translate"
        data-test="treatment-schema-description"
      />
    </mat-form-field>

    <mat-divider></mat-divider>
    @if (showMinOneTreatmentError) {
      <div class="notification notification-error" data-test="one-treatment-notification-error">
        <mat-icon>error</mat-icon>
        {{ 'chooseMinOneTreatment' | translate }}
      </div>
    }
    <div class="mat-checkbox-row-wrapper" formGroupName="treatmentIds">
      @for (treatment of data.treatments; track treatment; let i = $index) {
        <div class="mat-checkbox-row" data-test="treatment-schema-parent">
          <mat-checkbox
            color="primary"
            formControlName="{{ i }}"
            data-test="treatment-schema-option"
          >
            {{ treatment.name }}</mat-checkbox
          >
        </div>
      }
    </div>
  </div>
</agr-form-dialog>
